import { toRepeatQuery } from './queryString'
import { DownloadInventoryPriceStatusesReq, GetInventoryPriceStatusesReq } from './types'

/**
 * ST11(신규) 재고현황(단가) 화면이 쓰는 엔드포인트.
 *
 * 동작별 배선 (LOGISPRD-10668 기준표):
 * | 동작     | 2.0 API                                      | 1.0 API           | 비고                     |
 * |----------|----------------------------------------------|-------------------|--------------------------|
 * | 화면     | —                                            | —                 | FE 전용 신규 페이지(st11), 기존 st07(iframe) 유지 |
 * | 조회     | `GET /api/v1/inventory/price-statuses`       | /api/grid/search  | LOGISPRD-9596            |
 * | 다운로드 | `GET /api/v1/inventory/price-statuses/excel` | —                 | LOGISPRD-9597 (서버 엑셀) |
 */
export const INVENTORY_PRICE_STATUSES_URL = '/api/v1/inventory/price-statuses'
export const INVENTORY_PRICE_STATUSES_EXCEL_URL = `${INVENTORY_PRICE_STATUSES_URL}/excel`

/** 조회 요청 URL. */
export const buildInventoryPriceStatusesUrl = (params: GetInventoryPriceStatusesReq) =>
  `${INVENTORY_PRICE_STATUSES_URL}?${toRepeatQuery(params)}`

/** 엑셀 다운로드 URL. blob 으로 받아 저장한다. */
export const buildInventoryPriceStatusesExcelUrl = (params: DownloadInventoryPriceStatusesReq) =>
  `${INVENTORY_PRICE_STATUSES_EXCEL_URL}?${toRepeatQuery(params)}`
